// src/components/Layout/RoleForm.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { createRol, updateRol, getRoles } from '../../services/api';
import { AuthContext } from '../../contexts/AuthContext';

const RoleForm = () => {
  const [rol, setRol] = useState({
    nombre: '',
    crearProductos: false,
    modificarPrecios: false,
    verReportes: false,
    crearUsuarios: false,
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { nombre } = useParams(); // Para editar
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (nombre) {
      // Si hay un nombre, es edición. Obtener datos del rol.
      const fetchRol = async () => {
        try {
          const data = await getRoles();
          if (data.success) {
            const existingRol = data.data.find((r) => r.nombre === nombre);
            if (existingRol) {
              setRol(existingRol);
            } else {
              setError('Rol no encontrado');
            }
          } else {
            setError('Error al obtener roles');
          }
        } catch (err) {
          setError(err.error || 'Error al obtener roles');
        }
      };
      fetchRol();
    }
  }, [nombre]);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setRol({
      ...rol,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (nombre) {
        // Actualizar rol
        const data = await updateRol(rol);
        if (data.success) {
          navigate('/roles');
        } else {
          setError('Error al actualizar rol');
        }
      } else {
        // Crear rol
        const data = await createRol(rol);
        if (data.success) {
          navigate('/roles');
        } else {
          setError('Error al crear rol');
        }
      }
    } catch (err) {
      setError(err.error || 'Error en la operación');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={4} p={4} boxShadow={3}>
        <Typography variant="h5" gutterBottom>
          {nombre ? 'Editar Rol' : 'Crear Rol'}
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <form onSubmit={handleSubmit}>
          {/* Nombre del Rol */}
          <TextField
            label="Nombre del Rol"
            variant="outlined"
            fullWidth
            margin="normal"
            name="nombre"
            value={rol.nombre}
            onChange={handleChange}
            required
            disabled={nombre ? true : false} // No permitir cambiar el nombre al editar
          />

          {/* Permisos */}
          <FormControlLabel
            control={
              <Checkbox
                checked={rol.crearProductos}
                onChange={handleChange}
                name="crearProductos"
                color="primary"
              />
            }
            label="Crear Productos"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rol.modificarPrecios}
                onChange={handleChange}
                name="modificarPrecios"
                color="primary"
              />
            }
            label="Modificar Precios"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rol.verReportes}
                onChange={handleChange}
                name="verReportes"
                color="primary"
              />
            }
            label="Ver Reportes"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rol.crearUsuarios}
                onChange={handleChange}
                name="crearUsuarios"
                color="primary"
              />
            }
            label="Crear Usuarios"
          />

          <Box mt={2}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {nombre ? 'Actualizar' : 'Crear'}
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default RoleForm;
